const $ = require('jquery');
// #Booking Form validation
import 'parsleyjs/dist/parsley.min.js';
import intlTelInput from 'intl-tel-input';
import 'select2';


console.log(Parsley);
class Checkout {

  constructor() {
    // this.$ = jQuery;
    // const $ = this.$;
  }

  init() {
    // const $ = this.jQuery;
    if ($('body').hasClass('page-template-book')) {
      console.log('init checkout');
      this.formValidation();
      this.initServices(jQuery);
      this.paymentOptions(jQuery);
      this.internationalTelInput();
      this.initCountry();
      this.initDocumentType();
      this.initLanguage();
      this.initPaymentOption();
      this.initPlusMinusButtons();
      this.ajaxSubmitForm(jQuery);
    }
  }

  initPlusMinusButtons = () => {
    function calculateTotal($optionalsTotal) {
      const $total = $('.book__form__total__final');
      const $totalRoom = parseFloat($total.data('roomtotal'));
      $total.empty().html($totalRoom + $optionalsTotal);

    }

    function calculateOptionals() {
      const $bookFormOptionals = $('.book__form__optionals');
      let $optionalsTotal = 0;
      $bookFormOptionals.empty();
      $bookFormOptionals.append('<ul>');
      const $services = $('.service__included__value');
      $services.each(function (index, value) {
        if ($(this).val() > 0) {
          $bookFormOptionals.append('<li><b>' + $(this).val() + '</b> x <b>' + $(this).data('name') +
            '</b> price: ' + $(this).data('price') +
            ', service Total Line:<b> ' + $(this).data('price') * $(this).val() + '€</b></li>');
        }
        $optionalsTotal = $optionalsTotal + parseFloat(parseFloat($(this).data('price')) * parseFloat($(this).val()));
      });
      $bookFormOptionals.append('</ul>');
      console.log($optionalsTotal);
      return $optionalsTotal;

    }

    console.log('initPlusMinusButtons');
    const $minus = $('.minus');
    const $plus = $('.plus');

    $minus.on('click', function (e) {

      if (parseInt($(this).next().val()) !== 0) {
        $(this).next().val(parseInt($(this).next().val()) - 1);
      }
      let $optionalsTotal = calculateOptionals();
      let totalWithServices = calculateTotal($optionalsTotal);
    });

    $plus.on('click', function () {

      if (parseInt($(this).prev().val()) < $(this).prev().attr('max')) {
        $(this).prev().val(parseInt($(this).prev().val()) + 1);
      }
      let $optionalsTotal = calculateOptionals();
      console.log($optionalsTotal);
      let totalWithServices = calculateTotal($optionalsTotal)
    });
  }

  initPaymentOption = () => {
    //Countr
    const select2 = $('select[name="payment_option"]').select2({
      minimumResultsForSearch: Infinity,
      dropdownParent: $('.checkout-form'),
    });
  }

  initLanguage = () => {
    //Countr
    const select2 = $('select[name="Language"]').select2({
      minimumResultsForSearch: Infinity,
      dropdownParent: $('.checkout-form'),
    });
  }

  initCountry = () => {
    //Countr
    const select2 = $('select[name="Country"]').select2({
      minimumResultsForSearch: Infinity,
      dropdownParent: $('.checkout-form'),
    });
  }

  initDocumentType = () => {
    //Countr
    const select2 = $('select[name="DocumentType"]').select2({
      minimumResultsForSearch: Infinity,
      dropdownParent: $('.checkout-form'),
      dropdownCssClass: "DocumentType--maxheight"
    });
  }


  initFocusLabel = () => {
    $inputs = $('input');
    console.log($inputs);

  }

  internationalTelInput = () => {
    const input = document.querySelector("#telephone");
    const output = document.querySelector("#output");
    let iti = intlTelInput(input, {
      autoHideDialCode: false,
      nationalMode: true,
      initialCountry: 'auto',
      separateDialCode: true,
      hiddenInput: "contact-phone-full",
      geoIpLookup: callback => {
        $.get('https://ipinfo.io', () => {
        }, 'jsonp').always(resp => {
          callback((resp && resp.country) ? resp.country : '');
        });
      },
      preferredCountries: [],
    });
    $("#telephone").css('opacity', 1);
    input.addEventListener('change', this.handleChange);
    input.addEventListener('keyup', this.handleChange);
    $('.iti__flag-container').on('click', function () { input.value = '' });
  }

  handleChange = () => {
    let text;
    let countryCode = $('.iti__active').data('dial-code');
    const input = document.querySelector("#telephone");
    if (input.value) {
      text = countryCode + input.value;
      $('[name="fulltelephone"]').val('+' + text);
    };
    return text;
  }

  ajaxSubmitForm = () => {
    const $form = $('.checkout-form');
    const $formResponse = $('.checkout-form-response');
    const $submitCheckout = $('.submit-checkout');
    const formValidationFunc = this.formValidation();
    $submitCheckout.on('click', function (e) {
      e.preventDefault();
      // formValidationFunc;
      $('.checkout-form').submit();
      console.log('submit checkout prevent default');
    });
    // var form = $('#contactForm1');
    $form.on('submit', function (e) {
      console.log('form-submited');
      e.preventDefault();
      // $('.villas-loader').show();
      $('.villas-loader').addClass('loading');
      $('.single-villas__checkout-form__loading').css('width', '50%');
      $('.single-villas__checkout-form__loading').css('max-width', '50%');
      console.log('return false ajax submision');
      // return false;
      console.log('FORMDATA' +  $form.serialize());
      // $.ajax({
      //   type: $form.attr('method'),
      //   url: $form.attr('action'),
      //   data: $form.serialize(),
      //   success: function (data) {
      //     // $('.villas-loader').hide();
      //     $('.single-villas__checkout-form__loading').css('width', '100%');
      //     $('.single-villas__checkout-form__loading').css('max-width', '100%');
      //     $('.villas-loader').removeClass('loading');
      //     console.log('Submission was successful.');
      //     console.log(data);
      //     const parser = new DOMParser();
      //     data = parser.parseFromString(data, "text/xml");
      //     console.log(data);
      //     // Access the "Success" property
      //     let success = data.Success;
      //     if (data.success === undefined) {
      //       // Access the "ErrorList" property
      //       let errorList = data.ErrorList ?? null;
      //       // Access the "Error" property within "ErrorList"
      //       let error = errorList.Error ?? null;
      //       // Access specific properties within the "Error" object
      //       let errorId = error.ErrorId ?? null;
      //       let errorMessage = error.ErrorMessage ?? null;
      //       console.log("Error Id: " + errorId);
      //       console.log("Error Message: " + errorMessage);
      //       // $formResponse.empty().html(errorId + ' / ' + errorMessage);
      //       console.log('errorMessage', errorId, errorMessage)
      //     } else {
      //       console.log("Success: " + success);
      //       $formResponse.empty().html(data);
      //     }
      //     $('.single-villas__checkout-form__loading').css('width', '0%');
      //     $('.single-villas__checkout-form__loading').css('max-width', '0%');
      //     $('.single-villas__checkout-form__loading').removeClass('active');
      //   },
      //   error: function (data) {
      //     console.log('An error occurred.');
      //     console.log(data);
      //     $formResponse.empty().html('An error Has occured , please try again.');
      //     $('.single-villas__checkout-form__loading').css('width', '0');
      //     $('.single-villas__checkout-form__loading').css('max-width', '0');
      //     $('.single-villas__checkout-form__loading').removeClass('active');
      //   },
      // });
      document.querySelector('.submit-checkout').addEventListener('click', (e) => {
        e.preventDefault();
    
        // Retrieve values from input fields
        const firstName = document.getElementById('name').value;
        const lastName = document.getElementById('surname').value;
        const customerEmail = document.getElementById('email').value;
        const requestKey = document.querySelector('[name="request_key"]').value;
        const accommodationId = document.querySelector('[name="accommodation_id"]').value;
        const checkIn = document.querySelector('[name="check_in"]').value;
        const checkOut = document.querySelector('[name="check_out"]').value;
    
        if (!firstName || !lastName || !customerEmail) {
          alert('Please fill in all required fields.');
          return;
        }
    
        // Make AJAX request to create Viva Wallet order
        jQuery.ajax({
          url: vivaWalletAjax.ajax_url,
          type: 'POST',
          data: {
            action: 'create_viva_order',
            security: vivaWalletAjax.nonce,
            request_key: requestKey,
            currency: 978,
            customer_email: customerEmail,
            customer_name: `${firstName} ${lastName}`,
            accommodation_id: accommodationId,
            check_in: checkIn,
            check_out: checkOut
          },
          success(response) {
            if (response.success) {
              window.location.href = response.data.payment_url;
            } else {
              console.log(`Error creating order: ${response.data.message}`);
            }
          },
          error(xhr, status, error) {
            console.log(`An error occurred: ${error}`);
          }
        });
      });
 
      // For this example, let's simulate a delay with setTimeout
      setTimeout(function () {
        // Hide the loader when the processing is complete
        $('.single-villas__checkout-form__loading').removeClass('active');
      }, 20);

    });
  }

  paymentOptions = ($) => {
    const $payments__option = $('.payments__options');
    $payments__option.on('change', function () {
      console.log($payments__option.find(":selected").val());
      console.log($payments__option.find(":selected").text());
    });
  }

  formValidation = () => {
    // $('.checkout-form').parsley();
    console.log('check valiadation input');
    $('.checkout-form').parsley().on('field:validated', function (e) {
      var ok = $('.parsley-error').length === 0;
      $('.bs-callout-info').toggleClass('hidden', !ok);
      $('.bs-callout-warning').toggleClass('hidden', ok);

    })
      .on('form:submit', function () {
        // return false; // Don't submit form for this demo
      });
  }

  financial = (x) => {
    return Number.parseFloat(x).toFixed(2);
  }

  updateFormServices = ($) => {
    const $optionalServices = $('.service__included__value');
    $optionalServices.each(element => {
      console.log($(element).val());
      console.log($(element).data('name'));
      console.log($(element).data('price'));
    });
  }

  initServices = ($) => {
    console.log($);
    console.log('init services');
    const $optionalServices = $('.service__included__value');
    $optionalServices.on('change', function (e) {
      console.log(e);
      console.log(e.currentTarget);
      console.log($(e.currentTarget).val());
      console.log($(e.currentTarget).data('name'));
      console.log($(e.currentTarget).data('price'));
      //add the additional costs in total cost
      // this.updateFormServices($);
      let total = 0;
      const $optionalServices = $('.service__included__value');
      $('.service__included__value').each(function () {
        // console.log($(this).val());
        // console.log($(this).data('name'));
        // console.log($(this).data('price'));
        total += parseFloat($(this).val() * parseFloat($(this).data('price')))
      });
      total += parseFloat($('[name="total_cost"]').val());
      // $('.total__final').empty().html(total.toFixed(2));
      $('.total__final').empty().html(total.toFixed(2));
    });
  }
}

export { Checkout };